export default "__VITE_ASSET__DiWR1Li0__"